<template>
  <div class="calculator__calculator-item">
    <div class="calculator__row flex flex--align-center flex--wrap">
      <div class="calculator__value">
        <span>{{ inputValueComputed }} GB</span> storage
      </div>
    </div>
    <div class="calculator__row calculator__row-slider">
      <div class="calculator__slider-wrapper">
        <div class="background-main"></div>
        <div
          class="background"
          :style="{ width: `calc(${width}% - 13px)` }"
        ></div>
        <input
          type="range"
          min="0"
          :max="max"
          step="1"
          v-model="sliderModelComputed"
          @input="handleFocus(true)"
        />
      </div>
      <div
        class="calculator__labels-row flex flex--align-center"
        :style="{ '--items': item.labels.length }"
      >
        <span
          v-for="(label, idx) in item.labels"
          :style="{
            '--c': idx,
            fontWeight: sliderModelComputed === idx ? '600' : '',
            color: sliderModelComputed === idx ? '#1B1D1F' : '',
          }"
          :key="label"
          class="calculator__tick"
          :class="{ inactive: sliderModelComputed < idx }"
        >
          {{ handleFormat(label) }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SliderItem",
  props: ["item"],
  data() {
    return {
      sliderFocus: false,
      showSelect: false,
      showCustomSelect: false,
      selectValue: this.item?.customSelect?.selectDefault ?? null,
      inputValue: this.item.inputSlider,
      sliderModel: this.handleMaximum(this.item.inputSlider),
      mbValue: this.item?.inputMb?.selectDefault ?? null,
      formatter: Intl.NumberFormat("en", { notation: "compact" }),
    };
  },
  mounted() {
    this.handleFocus(true);
  },
  computed: {
    storage() {
      let def = {
        input: this.inputValue,

        key: this.item.title,
      };

      if (this.item.inputMb) {
        def = {
          ...def,
          mb: parseFloat(this.mbValue),
        };
      }

      if (this.item?.customSelect?.select) {
        def = {
          ...def,
          select: this.selectValue,
        };
      }

      return def;
    },
    inputValueComputed: {
      get() {
        return Intl.NumberFormat("en").format(this.inputValue);
      },
      set(val) {
        let normalizeNumber = Math.ceil(this.normalizeNumber(val));
        if (isNaN(normalizeNumber)) normalizeNumber = 0;
        let idx = this.handleMaximum(normalizeNumber);
        this.inputValue = normalizeNumber;
        if (!this.sliderFocus)
          this.sliderModelComputed = idx < 0 ? this.max : idx;
      },
    },
    sliderModelComputed: {
      get() {
        return this.sliderModel;
      },
      set(val) {
        this.sliderModel = val;
        if (this.sliderFocus) this.inputValueComputed = this.item.labels[val];
      },
    },
    max() {
      let items = this.item.labels.length - 1;
      return this.sliderFocus ? items : items * 2;
    },
    width() {
      let w = Math.ceil(((this.sliderModelComputed - 0) * 100) / this.max);
      return w;
    },
  },

  watch: {
    storage: {
      handler() {
        this.$emit("handle-storage", this.storage);
      },
      deep: true,
    },
  },

  methods: {
    handleFocus(focus) {
      this.sliderFocus = focus;

      if (!focus) {
        let idx =
          this.normalizeNumber(this.inputValueComputed) >
          this.item.labels[this.item.labels.length - 1]
            ? this.max
            : this.handleMaximum(this.inputValueComputed);
        this.sliderModelComputed = idx;
      }

      if (focus) {
        this.sliderModelComputed = this.handleMaximum(this.inputValueComputed);
      }
    },
    handleMaximum(val) {
      let normalize = this.normalizeNumber(val);
      let idx = this.item.labels.findIndex((it) => it >= normalize);
      let labelsVal = this.item.labels[idx];
      if (!this.sliderFocus) {
        idx *= 2;

        if (normalize < labelsVal) {
          idx -= 1;
        }
      }

      return idx;
    },
    handleFormat(num) {
      return this.formatter.format(num);
    },
    normalizeNumber(number) {
      if (typeof number === "string") {
        return parseFloat(number.replaceAll(",", ""));
      }
      return number;
    },
  },
};
</script>

<style lang="scss" scoped>
.calculator__labels-row {
  position: relative;
  margin-top: 10px;
  justify-content: space-between;
  width: 50%;
  --items: 1;

  .calculator__tick {
    position: relative;
    text-align: center;
    font-weight: 400;
    font-size: 15px;
    color: #a4a4a5;
    flex: 1;

    &::before {
      content: "";
      position: absolute;
      top: -23px;
      left: 50%;
      transform: translateX(-50%);
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: #067be0;
    }
    &.inactive::before {
      background-color: #a4a4a5; /* Light gray for inactive dots */
    }
  }
}
.calculator__labels-row .calculator__tick {
  margin-right: 0px;
}
.calculator__labels-row span:not(:first-child) {
  transform: translateX(0%);
}
.calculator__labels-row {
  margin: 0px;
}
.calculator__tick-hidden {
  visibility: hidden;
}
@media (max-width: 767px) {
  .price__cards .calculator__tick {
    font-size: 14px;
  }
}

@media (max-width: 450px) {
  .calculator__tick {
    font-size: 14px;
  }
  .calculator__labels-row .calculator__tick {
    margin-right: -5px;
  }
}
</style>
